"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var JobMixin = /** @class */ (function () {
    function JobMixin() {
    }
    JobMixin.prototype.searchJobs = function (params, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.UnitJob.parse, "warn"));
        };
        this.http.get("/jobs", params, this.unauthenticatedCallback(wrappedCallback));
    };
    JobMixin.prototype.getGravelerLogs = function (jobId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiStringResult(response));
        };
        this.http.get("/graveler-logs/" + jobId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    JobMixin.prototype.getJob = function (jobId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.FullJob.parse));
        };
        this.http.get("/jobs/" + jobId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    JobMixin.prototype.editJob = function (jobId, changes, callback) {
        var _this = this;
        var wrappedCallback = function (_request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/jobs/" + jobId, null, changes, this.unauthenticatedCallback(wrappedCallback));
    };
    JobMixin.prototype.getStreetViewImage = function (jobId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            if (response.statusCode == 200) {
                var reader_1 = new FileReader();
                reader_1.onload = function () {
                    if (typeof reader_1.result == "string") {
                        callback({ key: "available", imageUrl: reader_1.result });
                    }
                    else {
                        callback({ key: "error", message: "Failed to encode image" });
                    }
                };
                reader_1.onerror = function () {
                    return callback({
                        key: "error",
                        message: "Failed to encode image: " + reader_1.error,
                    });
                };
                reader_1.readAsDataURL(response.response);
            }
            else if (response.statusCode == 204) {
                callback({ key: "none" });
            }
            else {
                var failure = _this.apiFailureWithResponse(response);
                callback({
                    key: "error",
                    message: failure.success == false ? failure.message : "Unknown problem",
                });
            }
        };
        this.http.get("/jobs/" + jobId + "/street-view", null, this.unauthenticatedCallback(wrappedCallback), undefined, "blob");
    };
    return JobMixin;
}());
exports.default = JobMixin;
//# sourceMappingURL=JobMixin.js.map